import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import auctionsIcon from "../../assets/auctionsIcon.png";
import "./auctions.css";
import searchIcon from "../../assets/Search.png";
import Slider from "@mui/material/Slider";
import AuctionCard from "../../components/auctionCard/auctionCard";
import axios from "axios";
import { toast } from "react-toastify";
import AuctionDetails from "../../components/auctionDetails/auctionDetails";

// ── Web-app imports (kept for future use) ──
// import { useContext } from "react";
// import { UserContext } from "../../context/userContext";
// import { io } from "socket.io-client";
// import WinningCard from "../../components/winningCard/winningCard";
// import auctionsVector from "../../assets/auctionsVector.png";
// import walletVector from "../../assets/WalletVector.png";
// import transactionWallet from "../../assets/transactionsVector.png";
// import chatVector from "../../assets/chatVector.png";
// import requestVector from "../../assets/request.png";
// ──────────────────────────────────────────

const Auctions = () => {
  const { t } = useTranslation();
  const [auctions, setAuctions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showAuctionDetails, setShowAuctionDetails] = useState(false);
  const [selectedAuction, setSelectedAuction] = useState(null);
  // const navigate = useNavigate(); // restored when web-app mode returns

  async function handleShowAllAuctions() {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + "auctions/get-all-auctions",
        { params: { type: "Live" } }
      );
      if (response.status === 200 || response.status === 201) {
        setAuctions(response.data.data);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }

  async function handleShowAllOpenAuctions() {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + "auctions/get-all-auctions",
        { params: { type: "Open" } }
      );
      if (response.status === 200 || response.status === 201) {
        setAuctions(response.data.data);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }

  async function handleShowCategoryAuctions(id) {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + "auctions/get-auctions-by-category",
        { params: { category_id: +id, type: "Live" } }
      );
      if (response.status === 200 || response.status === 201) {
        setAuctions(response.data.data);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BASE_URL + "categories/get-all-categories")
      .then((res) => setCategories(res.data.data));

    axios
      .get(process.env.REACT_APP_BASE_URL + "auctions/get-all-auctions", {
        params: { type: "Live" },
      })
      .then((response) => setAuctions(response.data.data))
      .catch((error) => toast.error(error.message));

    // ── Socket connection (kept for future use) ──
    // const socketConnection = io(process.env.REACT_APP_SOCKET_URL, {
    //   transports: ["websocket"],
    // });
    // setSocket(socketConnection);
    // return () => socketConnection.disconnect();
    // ──────────────────────────────────────────
  }, []);

  return (
    <div className="py-16 mt-20 mb-15 auctions-page">
      <AuctionDetails
        setOpen={setShowAuctionDetails}
        open={showAuctionDetails}
        auction={selectedAuction}
      />

      {/* Page title */}
      <div className="flex items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={3}
          stroke="currentColor"
          className="size-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m8.25 4.5 7.5 7.5-7.5 7.5"
          />
        </svg>
        <div className="flex">
          <img src={auctionsIcon} className="me-3 h-6 sm:h-9" alt="Auctions" />
          <div className="self-center text-xl font-bold whitespace-nowrap text-dark-grey dark:text-white">
            {t("auctions.title")}
          </div>
        </div>
      </div>

      {/* Filter buttons */}
      <div className="flex items-center flex-wrap mt-6 buttons-container me-10">
        <button
          type="button"
          className="focus:outline-none text-white font-bold rounded-lg text-sm px-5 py-2.5 mb-2 auction-button"
          onClick={handleShowAllAuctions}
        >
          {t("auctions.allAuctions")}
        </button>
        <button
          type="button"
          className="focus:outline-none text-white font-bold rounded-lg text-sm px-5 py-2.5 mb-2 auction-button"
          onClick={handleShowAllOpenAuctions}
        >
          {t("auctions.openAuctions")}
        </button>
        {categories.map((category) => (
          <button
            key={category.id}
            type="button"
            className="focus:outline-none text-white font-bold rounded-lg text-sm px-5 py-2.5 mb-2 auction-button"
            onClick={() => handleShowCategoryAuctions(category.id)}
          >
            {t("auctions.categoryPrefix")} {category.name}
          </button>
        ))}

        {/* ── Auth-required buttons (kept for future use) ──
        <button onClick={handleMyAuctions}>مزاداتى</button>
        <button onClick={handleWinnings}>مزادات ربحت بها</button>
        ── */}
      </div>

      <div className="flex flex-col md:flex-row mt-5">
        {/* Sidebar */}
        <div className="w-2/10 hidden md:block flex-row">
          <div className="relative">
            <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
              <img src={searchIcon} alt="Search Icon" className="w-4 h-4" />
            </div>
            <input
              type="search"
              id="default-search"
              className="block w-full p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
              placeholder={t("auctions.searchPlaceholder")}
            />
          </div>

          {/* ── Auth-required sidebar items (kept for future use) ──
          <div className="auctions-options mt-4 p-4 flex-row">
            <div onClick={() => navigate("/requestLiveAuction")}>تقديم طلب مزاد</div>
            <div onClick={handleMyAuctions}>مزاواداتى</div>
            <div>مزاوادات ربحت بها</div>
            <div>التحويلات</div>
            <div>الشات</div>
          </div>
          ── */}

          <div className="auctions-options mt-4 p-4 flex-row">
            <div className="flex items-center me-4">
              <input
                id="live-checkbox"
                type="checkbox"
                className="w-4 h-4 text-primary bg-gray-100 border-gray-300 rounded focus:ring-primary"
              />
              <label htmlFor="live-checkbox" className="ms-2 text-lg font-semibold text-gray-900">
                {t("auctions.liveCheckbox")}
              </label>
            </div>
            <div className="flex items-center me-4 mt-4">
              <input
                id="open-checkbox"
                type="checkbox"
                className="w-4 h-4 text-primary bg-gray-100 border-gray-300 rounded focus:ring-primary"
              />
              <label htmlFor="open-checkbox" className="ms-2 text-lg font-semibold text-gray-900">
                {t("auctions.openCheckbox")}
              </label>
            </div>
            <div className="flex items-center me-4 mt-4">
              <input
                id="single-checkbox"
                type="checkbox"
                className="w-4 h-4 text-primary bg-gray-100 border-gray-300 rounded focus:ring-primary"
              />
              <label htmlFor="single-checkbox" className="ms-2 text-lg font-semibold text-gray-900">
                {t("auctions.singleCheckbox")}
              </label>
            </div>
            <div className="flex items-center me-4 mt-4">
              <input
                id="ended-checkbox"
                type="checkbox"
                className="w-4 h-4 text-primary bg-gray-100 border-gray-300 rounded focus:ring-primary"
              />
              <label htmlFor="ended-checkbox" className="ms-2 text-lg font-semibold text-gray-900">
                {t("auctions.endedCheckbox")}
              </label>
            </div>

            <div className="mt-5">
              <select
                id="small"
                className="block w-full p-2 mb-6 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
              >
                <option>{t("auctions.region")}</option>
                <option value="US">United States</option>
                <option value="CA">Canada</option>
                <option value="FR">France</option>
                <option value="DE">Germany</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-900">
                {t("auctions.distance")}
              </label>
              <Slider
                size="small"
                defaultValue={70}
                aria-label="Small"
                valueLabelDisplay="auto"
                sx={{
                  color: "#00AEEB",
                  "& .MuiSlider-thumb": { backgroundColor: "#00AEEB" },
                  "& .MuiSlider-rail": { color: "gray" },
                }}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-900">
                {t("auctions.firstBidAmount")}
              </label>
              <Slider
                size="small"
                defaultValue={70}
                aria-label="Small"
                valueLabelDisplay="auto"
                sx={{
                  color: "#00AEEB",
                  "& .MuiSlider-thumb": { backgroundColor: "#00AEEB" },
                  "& .MuiSlider-rail": { color: "gray" },
                }}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-900">
                {t("auctions.itemArea")}
              </label>
              <Slider
                size="small"
                defaultValue={70}
                aria-label="Small"
                valueLabelDisplay="auto"
                sx={{
                  color: "#00AEEB",
                  "& .MuiSlider-thumb": { backgroundColor: "#00AEEB" },
                  "& .MuiSlider-rail": { color: "gray" },
                }}
              />
            </div>
          </div>
        </div>

        {/* Auction cards */}
        <div className="w-7/10 md:w-7/10 mx-auto flex-row">
          {auctions.map((auction) => (
            <AuctionCard
              key={auction.id}
              id={auction.id}
              startDate={auction.startDate}
              endDate={auction.expiryDate}
              type={auction.type}
              title={auction.title}
              imgURL={auction.image_url}
              owner={auction.user.name}
              products={auction.auction_products}
              price={auction.actualPrice}
              quantity={auction.quantity}
              subCategories={auction.Auction_subCategories_relations}
              handleShowAuctionDetails={() => {
                setShowAuctionDetails(true);
                setSelectedAuction(auction);
              }}
            />
          ))}

          {/* ── Web-app: winnings view (kept for future use) ──
          {showWinnings
            ? Object.keys(winnings).map((winning) => (
                <WinningCard key={winning} winnings={winnings[winning]} />
              ))
            : null}
          ── */}
        </div>
      </div>
    </div>
  );
};

export default Auctions;
